import React, { useState, useEffect } from 'react';
import { search_filter_Stock } from '../../../../../../services/stock_service';

import {
    Dialog, FormControl, InputLabel, Select, MenuItem, Grid, TextField, IconButton,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, 
    Button, Tooltip,Fab
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import PanToolAltTwoToneIcon from '@mui/icons-material/PanToolAltTwoTone';
import { padding } from '@mui/system';

const SearchStock = ({ open, onClose, categories,existing_products,get_supplier_by_id,suppliers,onChooseFromStock }) => {
    const [data, setData] = useState({ prodCategory: "", desc: "" });
    const [results, setResults] = useState([]);

    useEffect(() => {
        if (data.prodCategory || data.desc) {
            handleSearch();
        }
    }, [data]);

    const handleSearch = async () => {
        try {
            const response = await search_filter_Stock(data);
            setResults(response.data.data);
            
        } catch (error) {
            console.error("Erreur lors de la recherche:", error);
        }
    };

    const handleClear = () => {
        setData({ prodCategory: "", desc: "" });
        setResults([]);
    };

    const handleChooseFromStock = (product) => {
       //  console.log("choosed in search component",product);
        onChooseFromStock(product);
        
    }

    const existingProductCodes = new Set(existing_products.map(product => product.product_code));

    const filteredResults = results.filter(item => !existingProductCodes.has(item.products_by_supplier[0]?.product_code));

    return (
        <Dialog className="catalogue_modal" fullWidth={true} maxWidth={'xl'} centered open={open} onClose={onClose} >
            <div style={styles.container}>
                <div style={styles.searchSection}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={6}>
                            <FormControl variant="standard" fullWidth sx={styles.selectField}>
                                <InputLabel id="category-label">Famille d'achat</InputLabel>
                                <Select
                                    value={data.prodCategory}
                                    onChange={(e) => setData({ ...data, prodCategory: e.target.value })}
                                >
                                    <MenuItem value="">Toutes les familles d'achat</MenuItem>
                                    {categories.map((categorie) => (
                                        <MenuItem key={categorie.id_category} value={categorie.id_category}>
                                            {categorie.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container alignItems="center" sx={styles.searchBar}>
                                <Grid item sx={{ flexGrow: 1 }}>
                                    <TextField
                                        fullWidth
                                        label="Chercher"
                                        variant="standard"
                                        value={data.desc}
                                        onChange={(e) => setData({ ...data, desc: e.target.value })}
                                        sx={styles.textField}
                                    />
                                </Grid>
                                <Grid item>
                                    <IconButton onClick={handleClear} sx={styles.clearButton}>
                                        <CloseIcon />
                                    </IconButton>
                                </Grid>

                            </Grid>
                        </Grid>
                        {/* <Button 
                                    onClick={onClose} 
                                    variant="contained" 
                                    sx={styles.closeButton}
                                >
                                    Fermer
                        </Button> */}
                    </Grid>
                    
                </div>

                {results.length > 0 && (
                    <TableContainer component={Paper} sx={styles.tableContainer}>
                        <Table>
                            <TableHead>
                                <TableRow sx={styles.tableHeadRow}>
                                    <TableCell sx={styles.tableHeadCell}>Nom Produit</TableCell>
                                    <TableCell sx={styles.tableHeadCell}>Référence</TableCell>
                                    <TableCell sx={styles.tableHeadCell}>Code Produit</TableCell>
                                    <TableCell sx={styles.tableHeadCell}>ID Fournisseur</TableCell>
                                    <TableCell sx={styles.tableHeadCell}>Quantité</TableCell>
                                    <TableCell sx={styles.tableHeadCell}></TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredResults
                                .map((item, index) => (
                                    item.products_by_supplier.map((supplier, sIndex) => (
                                        <TableRow key={`${index}-${sIndex}`} sx={styles.tableRow}>
                                            <TableCell>{item.product_name || "N/A"}</TableCell>
                                            <TableCell>{item.product_reference || "N/A"}</TableCell>
                                            <TableCell>{supplier.product_code || "N/A"}</TableCell>
                                            <TableCell>{get_supplier_by_id(supplier.supplier,suppliers) || "N/A"}</TableCell>
                                            <TableCell>{supplier.product_quantity || "N/A"}</TableCell>
                                            <TableCell>   
                                                <Tooltip title="choisir">
                                                        <Fab className="add_new_object_fab add_new_object_fab_big" >
                                                            <PanToolAltTwoToneIcon className="my_icon" onClick={()=>handleChooseFromStock(item)} />
                                                        </Fab>
                                                </Tooltip>
                                            </TableCell>

                                        </TableRow>
                                    ))
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                
            </div>
        </Dialog>
    );
};

export default SearchStock;

const styles = {
    container: {
        padding: "20px",
        borderRadius: "10px",
    },
    searchSection: {
        display: "flex",
        gap: "10px",
        marginBottom: "20px",
        justifyContent:"end"
    },
    selectField: {
        minWidth: "220px",
        borderRadius: "5px",
    },
    searchBar: {
        display: "flex",
        alignItems: "end",
        padding: "5px 10px",
    },
    textField: {
        backgroundColor: "#fff",
        borderRadius: "5px",
        minWidth:"250px"
    },
    clearButton: {
        padding:0
    },
    tableHeadCell: {
        color: "#fff",
        fontWeight: "bold",
    },
    tableRow: {
        "&:hover": {
            backgroundColor: "#fdfdfd",
        },
    },
    closeButton: {
        marginTop: "15px",
        "&:hover": {
            backgroundColor: "#b71c1c",
        },
    },
};
